// import {createTheme} from "@mui/material";
import {createTheme} from "@mui/material/styles";

export const theme = (lgFontFg) => createTheme({
  palette: {
    primary: {main: "rgba(102, 153, 161, 1.0)"},
    neutral: {main: "rgba(51, 166, 184, 1.0)"},
    error: {main: "rgba(199, 62, 58, 1.0)"},
    accentS: {main: "rgba(30, 136, 168, 1.0)"},
    accentM: {main: "rgba(191, 103, 102, 1.0)"},
    accentY: {main: "rgba(233, 139, 42, 1.0)"},
    default: {main: "rgba(0, 0, 0, 0.54)"},
    success: {main: "rgba(36, 147, 110, 1.0)"},
    text: {disabled: "rgba(0, 0, 0, 0.4)"}
  },
  typography: {
    // fontFamily: ["Lucida Console"].join(","),
    fontSize: lgFontFg ? 18 : 15
  }
});
